import { Award, Briefcase, Users } from 'lucide-react';

const People = () => {
  const mentors = [
    {
      name: "Dr. Rajesh Kumar",
      title: "Serial Entrepreneur",
      expertise: "Fintech, SaaS",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=1287",
      companies: "Founded 3 startups, 2 successful exits"
    },
    {
      name: "Meera Iyer",
      title: "Venture Capitalist",
      expertise: "Investment Strategy",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1288",
      companies: "Partner at Sequoia Capital"
    },
    {
      name: "Vikram Reddy",
      title: "Product Leader",
      expertise: "Tech, Product Management",
      image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=1287",
      companies: "Ex-Google, Ex-Amazon"
    },
    {
      name: "Kavita Sharma",
      title: "Marketing Strategist",
      expertise: "Brand Building, Growth",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=1361",
      companies: "CMO at leading D2C brands"
    }
  ];

  const alumni = [
    {
      name: "Aditya Verma",
      batch: "2022",
      venture: "TechFlow Solutions",
      achievement: "Raised $500K seed funding",
      image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=1287"
    },
    {
      name: "Neha Gupta",
      batch: "2021",
      venture: "EcoPackage",
      achievement: "Sustainable packaging startup serving 50+ clients",
      image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?q=80&w=1287"
    },
    {
      name: "Karthik Menon",
      batch: "2023",
      venture: "SkillBridge",
      achievement: "Edtech platform with 10K+ users",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1287"
    },
    {
      name: "Riya Patel",
      batch: "2022",
      venture: "HealthFirst",
      achievement: "Healthcare logistics - Series A funded",
      image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=1287"
    }
  ];

  return (
    <div className="pt-20" data-testid="people-page">
      <section className="section-padding bg-gradient-to-b from-black to-[#121212]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-gold-500 mb-4">THE KAROBAR COMMUNITY</p>
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-black tracking-tighter uppercase mb-6" style={{ fontFamily: 'Open Sans' }}>OUR PEOPLE</h1>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">Meet the mentors guiding us and the alumni making waves in the startup ecosystem.</p>
          </div>

          <div className="mb-24">
            <div className="flex items-center justify-center space-x-4 mb-12">
              <Award className="text-gold-500" size={40} />
              <h2 className="text-4xl font-black text-center" style={{ fontFamily: 'Open Sans' }}>INDUSTRY MENTORS</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {mentors.map((mentor, index) => (
                <div key={index} className="glass-card overflow-hidden group" data-testid={`mentor-card-${index}`}>
                  <div className="relative h-64 overflow-hidden">
                    <img src={mentor.image} alt={mentor.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-black mb-1" style={{ fontFamily: 'Open Sans' }}>{mentor.name}</h3>
                    <p className="text-gold-500 text-sm font-semibold mb-2">{mentor.title}</p>
                    <p className="text-gray-400 text-sm mb-2">{mentor.expertise}</p>
                    <p className="text-gray-500 text-xs">{mentor.companies}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center justify-center space-x-4 mb-12">
              <Briefcase className="text-gold-500" size={40} />
              <h2 className="text-4xl font-black text-center" style={{ fontFamily: 'Open Sans' }}>SUCCESSFUL ALUMNI</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {alumni.map((alum, index) => (
                <div key={index} className="glass-card overflow-hidden group" data-testid={`alumni-card-${index}`}>
                  <div className="relative h-64 overflow-hidden">
                    <img src={alum.image} alt={alum.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    <div className="absolute top-4 right-4 bg-gold-500 text-black px-3 py-1 text-xs font-bold">
                      BATCH {alum.batch}
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-lg font-black mb-1" style={{ fontFamily: 'Open Sans' }}>{alum.name}</h3>
                    <p className="text-gold-500 text-sm font-semibold mb-3">{alum.venture}</p>
                    <p className="text-gray-400 text-sm leading-relaxed">{alum.achievement}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-24 glass-card p-12 text-center">
            <Users className="w-16 h-16 text-gold-500 mx-auto mb-6" />
            <h2 className="text-3xl font-black mb-4" style={{ fontFamily: 'Open Sans' }}>JOIN OUR COMMUNITY</h2>
            <p className="text-gray-400 text-lg mb-8 max-w-2xl mx-auto">Whether you're a mentor, investor, or successful alumni, we'd love to have you contribute to our ecosystem.</p>
            <a href="mailto:karobar.dps@christuniversity.in" className="btn-primary inline-block" data-testid="connect-with-us-button">
              CONNECT WITH US
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default People;